const translations = {
  de: {
    // Navbar
    accueil: 'Startseite',
    services: 'Dienste',
    apropos: 'Über uns',
    contact: 'Kontakt',
    gamme: 'Fahrzeuge',
    reserver: 'Buchen',
    connexion: 'Anmelden',
    sinscrire: 'Registrieren',
    // Gamme items
    comfortClassique: 'Classic Komfort',
    comfortPremium: 'Premium Komfort',
    prestige: 'Prestige',
    van: 'Van',
    // Hero
    serviceVtcPremium: 'Premium VTC Service',
    heroTitle1: 'Mehr als eine Fahrt,',
    heroTitle2: 'eine Erfahrung',
    heroSubtitle:
      'Strikte Pünktlichkeit, professionelle Fahrer und gepflegte Fahrzeuge. Ihr täglicher Mobilitätspartner.',
    reserverMaintenant: 'Jetzt buchen',
    nosServices: 'Unsere Dienste',
    decouvrir: 'Entdecken',
    // Services section
    nosServicesLabel: 'Unsere Dienste',
    servicesTitle1: 'Exzellenz im Dienst von',
    servicesTitle2: 'Ihrer Mobilität',
    // Service cards
    trajetsPonctuels: 'Punktuelle Fahrten',
    trajetsPonctuelsSubtitle: 'Ihre vereinfachte Alltagsmobilität',
    trajetsPonctuelsDesc:
      'Schnelle Buchung, professionelle und diskrete Fahrer, komfortable und gepflegte Fahrzeuge.',
    miseDispositionTitle: 'Fahrzeug auf Abruf',
    miseDispositionSubtitle: 'Privater Fahrer',
    miseDispositionDesc:
      'Ideal für Einkäufe, Geschäftstermine oder private Veranstaltungen. Einstellbare Dauer und Kilometrierung.',
    transfertsTitle: 'Bahnhof & Flughafen Transfers',
    transfertsSubtitle: 'Reisen Sie in völliger Ruhe',
    transfertsDesc:
      'Personalisierter Empfang mit Namenstafel. Echtzeit-Verfolgung der Fahrpläne. Gepäckhilfe.',
    affairesTitle: 'Geschäft & Events',
    affairesSubtitle: 'Exzellenz im Dienst Ihres Images',
    affairesDesc:
      'Professionell gekleidete Fahrer. Garantierte Diskretion und Vertraulichkeit. Gruppenlogistik.',
    // Fleet section
    notreFlotte: 'Unsere Flotte',
    fleetTitle1: 'Außergewöhnliche',
    fleetTitle2: 'Fahrzeuge',
    // Gamme descriptions
    comfortClassiqueDesc: 'Komfortable Limousine für Ihre täglichen Fahrten',
    comfortPremiumDesc: 'Hochwertige Fahrzeuge für überlegenen Komfort',
    prestigeDesc: 'Luxusfahrzeuge für ein außergewöhnliches Erlebnis',
    vanDesc: 'Geräumige Fahrzeuge für Gruppen und Familien',
    aPartirDe: 'Ab',
    // Booking section
    reservationLabel: 'Buchung',
    bookingTitle1: 'Buchen Sie Ihr VTC',
    bookingTitle2: 'ganz einfach',
    datePriseEnCharge: 'Abholtermin',
    choisirUneDate: 'Datum wählen',
    heurePriseEnCharge: 'Abholzeit',
    choisirUneHeure: 'Uhrzeit wählen',
    lieuPriseEnCharge: 'Abholort',
    adresseDepart: 'Abfahrtsadresse',
    lieuDepot: 'Abgabeort',
    adresseArrivee: 'Ankunftsadresse',
    typeTransfert: 'Transferart',
    choisirUnType: 'Typ wählen',
    sensUnique: 'Einweg',
    allerRetour: 'Hin und zurück',
    miseDisposition: 'Fahrzeug auf Abruf',
    // Why choose us
    pourquoiNousLabel: 'Warum wir',
    whyChooseTitle1: 'Warum',
    whyChooseTitle2: 'Econnect VTC wählen?',
    ponctualite: 'Pünktlichkeit',
    ponctualiteDesc: 'Immer pünktlich, Echtzeit-Tracking Ihres Fahrers.',
    securite: 'Sicherheit',
    securiteDesc: 'Verifizierte Fahrer und regelmäßig überprüfte Fahrzeuge.',
    excellence: 'Exzellenz',
    excellenceDesc: 'Premium-Service mit Aufmerksamkeit für jedes Detail.',
    confort: 'Komfort',
    confortDesc: 'Hochwertige, klimatisierte und perfekt gepflegte Fahrzeuge.',
    // Testimonials
    temoignagesLabel: 'Referenzen',
    testimonialsTitle1: 'Was unsere',
    testimonialsTitle2: 'Kunden sagen',
    // Footer
    navigation: 'Navigation',
    copyright: '© 2025 Econnect VTC. Alle Rechte vorbehalten.',
    mentionsLegales: 'Impressum',
    politiqueConfidentialite: 'Datenschutzrichtlinie',
    footerBrandDesc:
      'Ihr Premium-Mobilitätspartner. Qualitäts-VTC-Service für all Ihre geschäftlichen und privaten Fahrten.',
    footerNavAccueil: 'Startseite',
    footerNavServices: 'Dienste',
    footerNavReserver: 'Buchen',
    footerNavApropos: 'Über uns',
    footerNavContact: 'Kontakt',
  },
  it: {
    // Navbar
    accueil: 'Home',
    services: 'Servizi',
    apropos: 'Chi siamo',
    contact: 'Contatto',
    gamme: 'Gamma',
    reserver: 'Prenota',
    connexion: 'Accedi',
    sinscrire: 'Registrati',
    // Gamme items
    comfortClassique: 'Confort Classico',
    comfortPremium: 'Confort Premium',
    prestige: 'Prestige',
    van: 'Van',
    // Hero
    serviceVtcPremium: 'Servizio VTC Premium',
    heroTitle1: 'Più di un viaggio,',
    heroTitle2: "un'esperienza",
    heroSubtitle:
      'Puntualità rigorosa, autisti professionali e veicoli curati. Il vostro partner di mobilità quotidiano.',
    reserverMaintenant: 'Prenota ora',
    nosServices: 'I nostri servizi',
    decouvrir: 'Scopri',
    // Services section
    nosServicesLabel: 'I nostri Servizi',
    servicesTitle1: "L'eccellenza al servizio della",
    servicesTitle2: 'vostra mobilità',
    // Service cards
    trajetsPonctuels: 'Tragitti Puntuali',
    trajetsPonctuelsSubtitle: 'La tua mobilità quotidiana semplificata',
    trajetsPonctuelsDesc:
      'Prenotazione rapida, autisti professionali e discreti, veicoli confortevoli e curati.',
    miseDispositionTitle: 'A Disposizione',
    miseDispositionSubtitle: 'Autista Privato',
    miseDispositionDesc:
      'Ideale per shopping, appuntamenti professionali o eventi privati. Durata e chilometraggio regolabili.',
    transfertsTitle: 'Trasferimenti Stazioni & Aeroporti',
    transfertsSubtitle: 'Viaggiate in totale serenità',
    transfertsDesc:
      'Accoglienza personalizzata con cartello nominativo. Monitoraggio in tempo reale degli orari. Assistenza bagagli.',
    affairesTitle: 'Affari & Eventi',
    affairesSubtitle: "L'eccellenza al servizio della vostra immagine",
    affairesDesc:
      'Autisti in abito professionale. Discrezione e riservatezza garantite. Gestione logistica di gruppo.',
    // Fleet section
    notreFlotte: 'La nostra Flotta',
    fleetTitle1: 'Veicoli',
    fleetTitle2: "d'eccezione",
    // Gamme descriptions
    comfortClassiqueDesc: 'Berlina confortevole per i vostri tragitti quotidiani',
    comfortPremiumDesc: 'Veicoli di alta gamma per un comfort superiore',
    prestigeDesc: "Veicoli di lusso per un'esperienza eccezionale",
    vanDesc: 'Veicoli spaziosi per gruppi e famiglie',
    aPartirDe: 'A partire da',
    // Booking section
    reservationLabel: 'Prenotazione',
    bookingTitle1: 'Prenota il tuo VTC',
    bookingTitle2: 'in tutta semplicità',
    datePriseEnCharge: 'Data di presa in carico',
    choisirUneDate: 'Scegli una data',
    heurePriseEnCharge: 'Ora di presa in carico',
    choisirUneHeure: "Scegli un'ora",
    lieuPriseEnCharge: 'Luogo di presa in carico',
    adresseDepart: 'Indirizzo di partenza',
    lieuDepot: 'Luogo di deposito',
    adresseArrivee: 'Indirizzo di arrivo',
    typeTransfert: 'Tipo di trasferimento',
    choisirUnType: 'Scegli un tipo',
    sensUnique: 'Solo andata',
    allerRetour: 'Andata e ritorno',
    miseDisposition: 'A Disposizione',
    // Why choose us
    pourquoiNousLabel: 'Perché noi',
    whyChooseTitle1: 'Perché scegliere',
    whyChooseTitle2: 'Econnect VTC?',
    ponctualite: 'Puntualità',
    ponctualiteDesc: 'Sempre puntuali, tracciamento in tempo reale del vostro autista.',
    securite: 'Sicurezza',
    securiteDesc: 'Autisti verificati e veicoli controllati regolarmente.',
    excellence: 'Eccellenza',
    excellenceDesc: 'Servizio premium con attenzione ad ogni dettaglio.',
    confort: 'Confort',
    confortDesc: 'Veicoli di alta gamma, climatizzati e perfettamente curati.',
    // Testimonials
    temoignagesLabel: 'Testimonianze',
    testimonialsTitle1: 'Cosa dicono',
    testimonialsTitle2: 'i nostri clienti',
    // Footer
    navigation: 'Navigazione',
    copyright: '© 2025 Econnect VTC. Tutti i diritti riservati.',
    mentionsLegales: 'Note Legali',
    politiqueConfidentialite: 'Informativa sulla Privacy',
    footerBrandDesc:
      'Il vostro partner di mobilità premium. Servizio VTC di qualità per tutti i vostri spostamenti professionali e personali.',
    footerNavAccueil: 'Home',
    footerNavServices: 'Servizi',
    footerNavReserver: 'Prenota',
    footerNavApropos: 'Chi siamo',
    footerNavContact: 'Contatto',
  },
  pt: {
    // Navbar
    accueil: 'Início',
    services: 'Serviços',
    apropos: 'Sobre nós',
    contact: 'Contato',
    gamme: 'Gama',
    reserver: 'Reservar',
    connexion: 'Entrar',
    sinscrire: 'Registrar',
    // Gamme items
    comfortClassique: 'Conforto Clássico',
    comfortPremium: 'Conforto Premium',
    prestige: 'Prestígio',
    van: 'Van',
    // Hero
    serviceVtcPremium: 'Serviço VTC Premium',
    heroTitle1: 'Mais que uma viagem,',
    heroTitle2: 'uma experiência',
    heroSubtitle:
      'Pontualidade rigorosa, motoristas profissionais e veículos bem conservados. Seu parceiro de mobilidade diário.',
    reserverMaintenant: 'Reservar agora',
    nosServices: 'Nossos serviços',
    decouvrir: 'Descobrir',
    // Services section
    nosServicesLabel: 'Nossos Serviços',
    servicesTitle1: 'A excelência ao serviço da',
    servicesTitle2: 'sua mobilidade',
    // Service cards
    trajetsPonctuels: 'Viagens Pontuais',
    trajetsPonctuelsSubtitle: 'Sua mobilidade diária simplificada',
    trajetsPonctuelsDesc:
      'Reserva rápida, motoristas profissionais e discretos, veículos confortáveis e conservados.',
    miseDispositionTitle: 'À Disposição',
    miseDispositionSubtitle: 'Motorista Privado',
    miseDispositionDesc:
      'Ideal para compras, compromissos profissionais ou eventos privados. Duração e quilometragem ajustáveis.',
    transfertsTitle: 'Transferências Estações & Aeroportos',
    transfertsSubtitle: 'Viaje com total tranquilidade',
    transfertsDesc:
      'Recepção personalizada com placa nominativa. Acompanhamento em tempo real dos horários. Assistência de bagagem.',
    affairesTitle: 'Negócios & Eventos',
    affairesSubtitle: 'A excelência ao serviço da sua imagem',
    affairesDesc:
      'Motoristas em traje profissional. Discrição e confidencialidade garantidas. Gestão logística de grupo.',
    // Fleet section
    notreFlotte: 'Nossa Frota',
    fleetTitle1: 'Veículos',
    fleetTitle2: 'de exceção',
    // Gamme descriptions
    comfortClassiqueDesc: 'Berlina confortável para suas viagens diárias',
    comfortPremiumDesc: 'Veículos de alta gama para um conforto superior',
    prestigeDesc: 'Veículos de luxo para uma experiência excepcional',
    vanDesc: 'Veículos espaçosos para grupos e famílias',
    aPartirDe: 'A partir de',
    // Booking section
    reservationLabel: 'Reserva',
    bookingTitle1: 'Reserve seu VTC',
    bookingTitle2: 'com total facilidade',
    datePriseEnCharge: 'Data de coleta',
    choisirUneDate: 'Escolher uma data',
    heurePriseEnCharge: 'Hora de coleta',
    choisirUneHeure: 'Escolher um horário',
    lieuPriseEnCharge: 'Local de coleta',
    adresseDepart: 'Endereço de partida',
    lieuDepot: 'Local de entrega',
    adresseArrivee: 'Endereço de chegada',
    typeTransfert: 'Tipo de transferência',
    choisirUnType: 'Escolher um tipo',
    sensUnique: 'Somente ida',
    allerRetour: 'Ida e volta',
    miseDisposition: 'À Disposição',
    // Why choose us
    pourquoiNousLabel: 'Por que nós',
    whyChooseTitle1: 'Por que escolher',
    whyChooseTitle2: 'Econnect VTC?',
    ponctualite: 'Pontualidade',
    ponctualiteDesc: 'Sempre no horário, rastreamento em tempo real do seu motorista.',
    securite: 'Segurança',
    securiteDesc: 'Motoristas verificados e veículos regularmente inspecionados.',
    excellence: 'Excelência',
    excellenceDesc: 'Serviço premium com atenção a cada detalhe.',
    confort: 'Conforto',
    confortDesc: 'Veículos de alta gama, climatizados e perfeitamente conservados.',
    // Testimonials
    temoignagesLabel: 'Depoimentos',
    testimonialsTitle1: 'O que dizem',
    testimonialsTitle2: 'nossos clientes',
    // Footer
    navigation: 'Navegação',
    copyright: '© 2025 Econnect VTC. Todos os direitos reservados.',
    mentionsLegales: 'Aviso Legal',
    politiqueConfidentialite: 'Política de Privacidade',
    footerBrandDesc:
      'Seu parceiro de mobilidade premium. Serviço VTC de qualidade para todos os seus deslocamentos profissionais e pessoais.',
    footerNavAccueil: 'Início',
    footerNavServices: 'Serviços',
    footerNavReserver: 'Reservar',
    footerNavApropos: 'Sobre nós',
    footerNavContact: 'Contato',
  },
  nl: {
    // Navbar
    accueil: 'Home',
    services: 'Diensten',
    apropos: 'Over ons',
    contact: 'Contact',
    gamme: 'Aanbod',
    reserver: 'Boeken',
    connexion: 'Inloggen',
    sinscrire: 'Registreren',
    // Gamme items
    comfortClassique: 'Klassiek Confort',
    comfortPremium: 'Premium Confort',
    prestige: 'Prestige',
    van: 'Van',
    // Hero
    serviceVtcPremium: 'Premium VTC Service',
    heroTitle1: 'Meer dan een rit,',
    heroTitle2: 'een beleving',
    heroSubtitle:
      'Strikte stiptheid, professionele chauffeurs en goed onderhouden voertuigen. Uw dagelijkse mobiliteitspartner.',
    reserverMaintenant: 'Nu boeken',
    nosServices: 'Onze diensten',
    decouvrir: 'Ontdekken',
    // Services section
    nosServicesLabel: 'Onze Diensten',
    servicesTitle1: 'Uitmuntendheid in dienst van',
    servicesTitle2: 'uw mobiliteit',
    // Service cards
    trajetsPonctuels: 'Stipte Ritten',
    trajetsPonctuelsSubtitle: 'Uw vereenvoudigde dagelijkse mobiliteit',
    trajetsPonctuelsDesc:
      'Snelle boeking, professionele en discrete chauffeurs, comfortabele en goed onderhouden voertuigen.',
    miseDispositionTitle: 'Ter Beschikking',
    miseDispositionSubtitle: 'Privé Chauffeur',
    miseDispositionDesc:
      "Ideaal voor winkelen, professionele afspraken of privé-evenementen. Aanpasbare duur en kilometerstand.",
    transfertsTitle: 'Station & Luchthaven Transfers',
    transfertsSubtitle: 'Reis in alle rust',
    transfertsDesc:
      "Gepersonaliseerde ontvangst met naambordje. Real-time bijhouden van schema's. Bagage assistentie.",
    affairesTitle: 'Zaken & Evenementen',
    affairesSubtitle: 'Uitmuntendheid in dienst van uw imago',
    affairesDesc:
      'Professioneel geklede chauffeurs. Gegarandeerde discretie en vertrouwelijkheid. Groepslogistiek beheer.',
    // Fleet section
    notreFlotte: 'Onze Vloot',
    fleetTitle1: 'Uitzonderlijke',
    fleetTitle2: 'voertuigen',
    // Gamme descriptions
    comfortClassiqueDesc: 'Confortabele sedan voor uw dagelijkse ritten',
    comfortPremiumDesc: 'High-end voertuigen voor superieur comfort',
    prestigeDesc: 'Luxe voertuigen voor een uitzonderlijke ervaring',
    vanDesc: 'Ruime voertuigen voor groepen en families',
    aPartirDe: 'Vanaf',
    // Booking section
    reservationLabel: 'Boeking',
    bookingTitle1: 'Boek uw VTC',
    bookingTitle2: 'met gemak',
    datePriseEnCharge: 'Ophaaldatum',
    choisirUneDate: 'Kies een datum',
    heurePriseEnCharge: 'Ophaaltijd',
    choisirUneHeure: 'Kies een tijd',
    lieuPriseEnCharge: 'Ophaallocatie',
    adresseDepart: 'Vertrekadres',
    lieuDepot: 'Afzetlocatie',
    adresseArrivee: 'Aankomstadres',
    typeTransfert: 'Transfertype',
    choisirUnType: 'Kies een type',
    sensUnique: 'Enkele reis',
    allerRetour: 'Retour',
    miseDisposition: 'Ter Beschikking',
    // Why choose us
    pourquoiNousLabel: 'Waarom wij',
    whyChooseTitle1: 'Waarom',
    whyChooseTitle2: 'Econnect VTC kiezen?',
    ponctualite: 'Stiptheid',
    ponctualiteDesc: 'Altijd op tijd, real-time tracking van uw chauffeur.',
    securite: 'Veiligheid',
    securiteDesc: 'Geverifieerde chauffeurs en regelmatig geïnspecteerde voertuigen.',
    excellence: 'Uitmuntendheid',
    excellenceDesc: 'Premium service met aandacht voor elk detail.',
    confort: 'Confort',
    confortDesc: 'High-end, geklimatiseerde en perfect onderhouden voertuigen.',
    // Testimonials
    temoignagesLabel: 'Getuigenissen',
    testimonialsTitle1: 'Wat onze',
    testimonialsTitle2: 'klanten zeggen',
    // Footer
    navigation: 'Navigatie',
    copyright: '© 2025 Econnect VTC. Alle rechten voorbehouden.',
    mentionsLegales: 'Juridische Melding',
    politiqueConfidentialite: 'Privacybeleid',
    footerBrandDesc:
      'Uw premium mobiliteitspartner. Kwaliteits-VTC-service voor al uw professionele en persoonlijke verplaatsingen.',
    footerNavAccueil: 'Home',
    footerNavServices: 'Diensten',
    footerNavReserver: 'Boeken',
    footerNavApropos: 'Over ons',
    footerNavContact: 'Contact',
  },
  ru: {
    // Navbar
    accueil: 'Главная',
    services: 'Услуги',
    apropos: 'О нас',
    contact: 'Контакт',
    gamme: 'Автопарк',
    reserver: 'Забронировать',
    connexion: 'Войти',
    sinscrire: 'Зарегистрироваться',
    // Gamme items
    comfortClassique: 'Классический комфорт',
    comfortPremium: 'Премиум комфорт',
    prestige: 'Престиж',
    van: 'Ван',
    // Hero
    serviceVtcPremium: 'Премиум VTC сервис',
    heroTitle1: 'Больше чем поездка,',
    heroTitle2: 'незабываемый опыт',
    heroSubtitle:
      'Строгая пунктуальность, профессиональные водители и ухоженные автомобили. Ваш ежедневный партнёр по мобильности.',
    reserverMaintenant: 'Забронировать сейчас',
    nosServices: 'Наши услуги',
    decouvrir: 'Узнать больше',
    // Services section
    nosServicesLabel: 'Наши Услуги',
    servicesTitle1: 'Превосходство на службе',
    servicesTitle2: 'вашей мобильности',
    // Service cards
    trajetsPonctuels: 'Регулярные Поездки',
    trajetsPonctuelsSubtitle: 'Упрощённая ежедневная мобильность',
    trajetsPonctuelsDesc:
      'Быстрое бронирование, профессиональные и дискретные водители, комфортные и ухоженные автомобили.',
    miseDispositionTitle: 'Аренда с водителем',
    miseDispositionSubtitle: 'Частный Водитель',
    miseDispositionDesc:
      'Идеально для шопинга, деловых встреч или частных мероприятий. Настраиваемая продолжительность и километраж.',
    transfertsTitle: 'Трансферы на вокзал и в аэропорт',
    transfertsSubtitle: 'Путешествуйте в полном спокойствии',
    transfertsDesc:
      'Персонализированная встреча с именной табличкой. Отслеживание расписания в реальном времени. Помощь с багажом.',
    affairesTitle: 'Бизнес и Мероприятия',
    affairesSubtitle: 'Превосходство на службе вашего имиджа',
    affairesDesc:
      'Водители в профессиональной одежде. Гарантированная дискретность и конфиденциальность. Логистика для групп.',
    // Fleet section
    notreFlotte: 'Наш Автопарк',
    fleetTitle1: 'Исключительные',
    fleetTitle2: 'автомобили',
    // Gamme descriptions
    comfortClassiqueDesc: 'Комфортный седан для ваших ежедневных поездок',
    comfortPremiumDesc: 'Автомобили высокого класса для превосходного комфорта',
    prestigeDesc: 'Люксовые автомобили для исключительного опыта',
    vanDesc: 'Вместительные автомобили для групп и семей',
    aPartirDe: 'От',
    // Booking section
    reservationLabel: 'Бронирование',
    bookingTitle1: 'Забронируйте ваш VTC',
    bookingTitle2: 'очень просто',
    datePriseEnCharge: 'Дата подачи',
    choisirUneDate: 'Выбрать дату',
    heurePriseEnCharge: 'Время подачи',
    choisirUneHeure: 'Выбрать время',
    lieuPriseEnCharge: 'Место подачи',
    adresseDepart: 'Адрес отправления',
    lieuDepot: 'Место назначения',
    adresseArrivee: 'Адрес прибытия',
    typeTransfert: 'Тип трансфера',
    choisirUnType: 'Выбрать тип',
    sensUnique: 'В одну сторону',
    allerRetour: 'Туда и обратно',
    miseDisposition: 'Аренда с водителем',
    // Why choose us
    pourquoiNousLabel: 'Почему мы',
    whyChooseTitle1: 'Почему выбирают',
    whyChooseTitle2: 'Econnect VTC?',
    ponctualite: 'Пунктуальность',
    ponctualiteDesc: 'Всегда вовремя, отслеживание водителя в реальном времени.',
    securite: 'Безопасность',
    securiteDesc: 'Проверенные водители и регулярно проверяемые автомобили.',
    excellence: 'Превосходство',
    excellenceDesc: 'Премиум сервис с вниманием к каждой детали.',
    confort: 'Комфорт',
    confortDesc: 'Автомобили высокого класса, с климат-контролем и в идеальном состоянии.',
    // Testimonials
    temoignagesLabel: 'Отзывы',
    testimonialsTitle1: 'Что говорят',
    testimonialsTitle2: 'наши клиенты',
    // Footer
    navigation: 'Навигация',
    copyright: '© 2025 Econnect VTC. Все права защищены.',
    mentionsLegales: 'Юридическая информация',
    politiqueConfidentialite: 'Политика конфиденциальности',
    footerBrandDesc:
      'Ваш премиум партнёр по мобильности. Качественный VTC сервис для всех ваших деловых и личных поездок.',
    footerNavAccueil: 'Главная',
    footerNavServices: 'Услуги',
    footerNavReserver: 'Забронировать',
    footerNavApropos: 'О нас',
    footerNavContact: 'Контакт',
  },
  pl: {
    // Navbar
    accueil: 'Strona główna',
    services: 'Usługi',
    apropos: 'O nas',
    contact: 'Kontakt',
    gamme: 'Flota',
    reserver: 'Rezerwuj',
    connexion: 'Zaloguj się',
    sinscrire: 'Zarejestruj się',
    // Gamme items
    comfortClassique: 'Komfort Klasyczny',
    comfortPremium: 'Komfort Premium',
    prestige: 'Prestiż',
    van: 'Van',
    // Hero
    serviceVtcPremium: 'Usługa VTC Premium',
    heroTitle1: 'Więcej niż przejazd,',
    heroTitle2: 'niezwykłe doświadczenie',
    heroSubtitle:
      'Ścisła punktualność, profesjonalni kierowcy i zadbane pojazdy. Twój codzienny partner mobilności.',
    reserverMaintenant: 'Zarezerwuj teraz',
    nosServices: 'Nasze usługi',
    decouvrir: 'Odkryj',
    // Services section
    nosServicesLabel: 'Nasze Usługi',
    servicesTitle1: 'Doskonałość w służbie',
    servicesTitle2: 'Twojej mobilności',
    // Service cards
    trajetsPonctuels: 'Przejazdy Punktualne',
    trajetsPonctuelsSubtitle: 'Twoja uproszczona codzienna mobilność',
    trajetsPonctuelsDesc:
      'Szybka rezerwacja, profesjonalni i dyskretni kierowcy, komfortowe i zadbane pojazdy.',
    miseDispositionTitle: 'Do Dyspozycji',
    miseDispositionSubtitle: 'Prywatny Kierowca',
    miseDispositionDesc:
      'Idealne na zakupy, spotkania biznesowe lub prywatne wydarzenia. Regulowany czas trwania i kilometraż.',
    transfertsTitle: 'Transfery na Dworce & Lotniska',
    transfertsSubtitle: 'Podróżuj w pełnym spokoju',
    transfertsDesc:
      'Spersonalizowane powitanie z tabliczką z imieniem. Śledzenie rozkładów w czasie rzeczywistym. Pomoc z bagażem.',
    affairesTitle: 'Biznes & Eventy',
    affairesSubtitle: 'Doskonałość w służbie Twojego wizerunku',
    affairesDesc:
      'Kierowcy w stroju profesjonalnym. Gwarantowana dyskrecja i poufność. Zarządzanie logistyką grupową.',
    // Fleet section
    notreFlotte: 'Nasza Flota',
    fleetTitle1: 'Wyjątkowe',
    fleetTitle2: 'pojazdy',
    // Gamme descriptions
    comfortClassiqueDesc: 'Komfortowa limuzyna do codziennych przejazdów',
    comfortPremiumDesc: 'Pojazdy najwyższej klasy dla wyższego komfortu',
    prestigeDesc: 'Pojazdy luksusowe dla wyjątkowych doświadczeń',
    vanDesc: 'Przestronne pojazdy dla grup i rodzin',
    aPartirDe: 'Od',
    // Booking section
    reservationLabel: 'Rezerwacja',
    bookingTitle1: 'Zarezerwuj swój VTC',
    bookingTitle2: 'z łatwością',
    datePriseEnCharge: 'Data odbioru',
    choisirUneDate: 'Wybierz datę',
    heurePriseEnCharge: 'Godzina odbioru',
    choisirUneHeure: 'Wybierz godzinę',
    lieuPriseEnCharge: 'Miejsce odbioru',
    adresseDepart: 'Adres wyjazdu',
    lieuDepot: 'Miejsce docelowe',
    adresseArrivee: 'Adres przyjazdu',
    typeTransfert: 'Rodzaj transferu',
    choisirUnType: 'Wybierz typ',
    sensUnique: 'W jedną stronę',
    allerRetour: 'W obie strony',
    miseDisposition: 'Do Dyspozycji',
    // Why choose us
    pourquoiNousLabel: 'Dlaczego my',
    whyChooseTitle1: 'Dlaczego wybrać',
    whyChooseTitle2: 'Econnect VTC?',
    ponctualite: 'Punktualność',
    ponctualiteDesc: 'Zawsze na czas, śledzenie kierowcy w czasie rzeczywistym.',
    securite: 'Bezpieczeństwo',
    securiteDesc: 'Zweryfikowani kierowcy i regularnie kontrolowane pojazdy.',
    excellence: 'Doskonałość',
    excellenceDesc: 'Usługa premium z dbałością o każdy szczegół.',
    confort: 'Komfort',
    confortDesc: 'Pojazdy najwyższej klasy, klimatyzowane i w doskonałym stanie.',
    // Testimonials
    temoignagesLabel: 'Opinie',
    testimonialsTitle1: 'Co mówią',
    testimonialsTitle2: 'nasi klienci',
    // Footer
    navigation: 'Nawigacja',
    copyright: '© 2025 Econnect VTC. Wszelkie prawa zastrzeżone.',
    mentionsLegales: 'Informacje Prawne',
    politiqueConfidentialite: 'Polityka Prywatności',
    footerBrandDesc:
      'Twój premium partner mobilności. Jakościowa usługa VTC dla wszystkich Twoich podróży zawodowych i osobistych.',
    footerNavAccueil: 'Strona główna',
    footerNavServices: 'Usługi',
    footerNavReserver: 'Rezerwuj',
    footerNavApropos: 'O nas',
    footerNavContact: 'Kontakt',
  },
  ja: {
    // Navbar
    accueil: 'ホーム',
    services: 'サービス',
    apropos: '私たちについて',
    contact: 'お問い合わせ',
    gamme: '車種',
    reserver: '予約する',
    connexion: 'ログイン',
    sinscrire: '登録する',
    // Gamme items
    comfortClassique: 'クラシックコンフォート',
    comfortPremium: 'プレミアムコンフォート',
    prestige: 'プレステージ',
    van: 'バン',
    // Hero
    serviceVtcPremium: 'プレミアムVTCサービス',
    heroTitle1: '単なる移動以上の、',
    heroTitle2: '特別な体験を',
    heroSubtitle:
      '厳格な時間厳守、プロのドライバー、整備された車両。あなたの日常の移動パートナー。',
    reserverMaintenant: '今すぐ予約',
    nosServices: '私たちのサービス',
    decouvrir: '詳細を見る',
    // Services section
    nosServicesLabel: '私たちのサービス',
    servicesTitle1: 'あなたのモビリティのための',
    servicesTitle2: '卓越したサービス',
    // Service cards
    trajetsPonctuels: '定時運行',
    trajetsPonctuelsSubtitle: 'シンプルな日常の移動',
    trajetsPonctuelsDesc:
      'スピーディーな予約、プロフェッショナルかつ控えめなドライバー、快適で整備された車両。',
    miseDispositionTitle: '専用チャーター',
    miseDispositionSubtitle: 'プライベートドライバー',
    miseDispositionDesc:
      'ショッピング、仕事の会議、プライベートイベントに最適。時間と距離は調整可能。',
    transfertsTitle: '駅・空港送迎',
    transfertsSubtitle: '完全な安心で旅行を',
    transfertsDesc:
      'お名前ボードでのパーソナライズされたお迎え。リアルタイムのスケジュール追跡。荷物サポート。',
    affairesTitle: 'ビジネス＆イベント',
    affairesSubtitle: 'あなたのイメージのための卓越さ',
    affairesDesc:
      'プロフェッショナルな服装のドライバー。確実な慎重さと守秘義務。グループロジスティクス管理。',
    // Fleet section
    notreFlotte: '私たちの車種',
    fleetTitle1: '特別な',
    fleetTitle2: '車両',
    // Gamme descriptions
    comfortClassiqueDesc: '日常の移動に快適なセダン',
    comfortPremiumDesc: '優れた快適性のためのハイエンド車両',
    prestigeDesc: '特別な体験のための高級車両',
    vanDesc: 'グループや家族向けの広々とした車両',
    aPartirDe: '〜から',
    // Booking section
    reservationLabel: '予約',
    bookingTitle1: 'VTCを予約する',
    bookingTitle2: '簡単に',
    datePriseEnCharge: '乗車日',
    choisirUneDate: '日付を選択',
    heurePriseEnCharge: '乗車時間',
    choisirUneHeure: '時間を選択',
    lieuPriseEnCharge: '乗車場所',
    adresseDepart: '出発地住所',
    lieuDepot: '降車場所',
    adresseArrivee: '到着地住所',
    typeTransfert: '移送タイプ',
    choisirUnType: 'タイプを選択',
    sensUnique: '片道',
    allerRetour: '往復',
    miseDisposition: '専用チャーター',
    // Why choose us
    pourquoiNousLabel: 'なぜ私たちか',
    whyChooseTitle1: 'なぜ選ぶのか',
    whyChooseTitle2: 'Econnect VTC?',
    ponctualite: '時間厳守',
    ponctualiteDesc: '常に時間通り、ドライバーのリアルタイム追跡。',
    securite: '安全性',
    securiteDesc: '認証済みドライバーと定期的に点検された車両。',
    excellence: '卓越性',
    excellenceDesc: 'すべての細部に気を配るプレミアムサービス。',
    confort: '快適性',
    confortDesc: 'エアコン完備の高級車両、完璧にメンテナンス済み。',
    // Testimonials
    temoignagesLabel: 'お客様の声',
    testimonialsTitle1: 'お客様が',
    testimonialsTitle2: '語ること',
    // Footer
    navigation: 'ナビゲーション',
    copyright: '© 2025 Econnect VTC. All rights reserved.',
    mentionsLegales: '法的事項',
    politiqueConfidentialite: 'プライバシーポリシー',
    footerBrandDesc:
      'あなたのプレミアムモビリティパートナー。プロフェッショナルおよびパーソナルな移動のための高品質VTCサービス。',
    footerNavAccueil: 'ホーム',
    footerNavServices: 'サービス',
    footerNavReserver: '予約',
    footerNavApropos: '私たちについて',
    footerNavContact: 'お問い合わせ',
  },
  ko: {
    // Navbar
    accueil: '홈',
    services: '서비스',
    apropos: '소개',
    contact: '연락처',
    gamme: '차량',
    reserver: '예약하기',
    connexion: '로그인',
    sinscrire: '회원가입',
    // Gamme items
    comfortClassique: '클래식 컴포트',
    comfortPremium: '프리미엄 컴포트',
    prestige: '프레스티지',
    van: '밴',
    // Hero
    serviceVtcPremium: '프리미엄 VTC 서비스',
    heroTitle1: '단순한 이동이 아닌,',
    heroTitle2: '특별한 경험',
    heroSubtitle:
      '엄격한 시간 준수, 전문 기사, 잘 관리된 차량. 당신의 일상 이동 파트너.',
    reserverMaintenant: '지금 예약하기',
    nosServices: '우리의 서비스',
    decouvrir: '자세히 보기',
    // Services section
    nosServicesLabel: '우리의 서비스',
    servicesTitle1: '당신의 이동성을 위한',
    servicesTitle2: '탁월한 서비스',
    // Service cards
    trajetsPonctuels: '정시 이동',
    trajetsPonctuelsSubtitle: '간편한 일상 이동',
    trajetsPonctuelsDesc:
      '빠른 예약, 전문적이고 신중한 기사, 편안하고 잘 관리된 차량.',
    miseDispositionTitle: '전용 대여',
    miseDispositionSubtitle: '개인 기사',
    miseDispositionDesc:
      '쇼핑, 업무 미팅, 개인 행사에 이상적. 시간과 거리 조정 가능.',
    transfertsTitle: '역 & 공항 픽업',
    transfertsSubtitle: '완전한 편안함으로 여행하세요',
    transfertsDesc:
      '이름 팻말을 들고 맞이하는 맞춤형 영접. 일정 실시간 추적. 수하물 지원.',
    affairesTitle: '비즈니스 & 이벤트',
    affairesSubtitle: '당신의 이미지를 위한 탁월함',
    affairesDesc:
      '전문적인 복장의 기사. 보장된 신중함과 기밀성. 단체 물류 관리.',
    // Fleet section
    notreFlotte: '우리의 차량',
    fleetTitle1: '특별한',
    fleetTitle2: '차량들',
    // Gamme descriptions
    comfortClassiqueDesc: '일상 이동을 위한 편안한 세단',
    comfortPremiumDesc: '뛰어난 편안함을 위한 고급 차량',
    prestigeDesc: '특별한 경험을 위한 럭셔리 차량',
    vanDesc: '단체와 가족을 위한 넓은 차량',
    aPartirDe: '~부터',
    // Booking section
    reservationLabel: '예약',
    bookingTitle1: 'VTC 예약하기',
    bookingTitle2: '간편하게',
    datePriseEnCharge: '탑승 날짜',
    choisirUneDate: '날짜 선택',
    heurePriseEnCharge: '탑승 시간',
    choisirUneHeure: '시간 선택',
    lieuPriseEnCharge: '탑승 위치',
    adresseDepart: '출발 주소',
    lieuDepot: '하차 위치',
    adresseArrivee: '도착 주소',
    typeTransfert: '이동 유형',
    choisirUnType: '유형 선택',
    sensUnique: '편도',
    allerRetour: '왕복',
    miseDisposition: '전용 대여',
    // Why choose us
    pourquoiNousLabel: '왜 우리인가',
    whyChooseTitle1: '왜 선택하는가',
    whyChooseTitle2: 'Econnect VTC?',
    ponctualite: '시간 준수',
    ponctualiteDesc: '항상 정시에, 기사 실시간 추적.',
    securite: '안전성',
    securiteDesc: '검증된 기사와 정기적으로 점검된 차량.',
    excellence: '탁월성',
    excellenceDesc: '모든 세부 사항에 주의를 기울이는 프리미엄 서비스.',
    confort: '편안함',
    confortDesc: '고급, 에어컨 완비, 완벽하게 유지된 차량.',
    // Testimonials
    temoignagesLabel: '고객 후기',
    testimonialsTitle1: '고객들이',
    testimonialsTitle2: '말하는 것',
    // Footer
    navigation: '내비게이션',
    copyright: '© 2025 Econnect VTC. 모든 권리 보유.',
    mentionsLegales: '법적 고지',
    politiqueConfidentialite: '개인정보 처리방침',
    footerBrandDesc:
      '당신의 프리미엄 이동성 파트너. 모든 업무 및 개인 이동을 위한 고품질 VTC 서비스.',
    footerNavAccueil: '홈',
    footerNavServices: '서비스',
    footerNavReserver: '예약',
    footerNavApropos: '소개',
    footerNavContact: '연락처',
  },
  zh: {
    // Navbar
    accueil: '主页',
    services: '服务',
    apropos: '关于我们',
    contact: '联系我们',
    gamme: '车型',
    reserver: '预订',
    connexion: '登录',
    sinscrire: '注册',
    // Gamme items
    comfortClassique: '经典舒适',
    comfortPremium: '高级舒适',
    prestige: '豪华',
    van: '商务车',
    // Hero
    serviceVtcPremium: '高级VTC服务',
    heroTitle1: '不仅仅是一次出行，',
    heroTitle2: '更是一次体验',
    heroSubtitle:
      '严格守时，专业司机，精心维护的车辆。您的日常出行伙伴。',
    reserverMaintenant: '立即预订',
    nosServices: '我们的服务',
    decouvrir: '了解更多',
    // Services section
    nosServicesLabel: '我们的服务',
    servicesTitle1: '卓越服务于',
    servicesTitle2: '您的出行',
    // Service cards
    trajetsPonctuels: '准时出行',
    trajetsPonctuelsSubtitle: '简化您的日常出行',
    trajetsPonctuelsDesc:
      '快速预订，专业低调的司机，舒适维护良好的车辆。',
    miseDispositionTitle: '专属包车',
    miseDispositionSubtitle: '私人司机',
    miseDispositionDesc:
      '适合购物、商务会议或私人活动。时间和里程可调。',
    transfertsTitle: '车站及机场接送',
    transfertsSubtitle: '安心出行',
    transfertsDesc:
      '个性化接机，附名牌标识。实时行程追踪。行李协助。',
    affairesTitle: '商务与活动',
    affairesSubtitle: '卓越服务您的形象',
    affairesDesc:
      '专业着装的司机。保证谨慎和保密性。团体物流管理。',
    // Fleet section
    notreFlotte: '我们的车型',
    fleetTitle1: '卓越',
    fleetTitle2: '车辆',
    // Gamme descriptions
    comfortClassiqueDesc: '适合日常出行的舒适轿车',
    comfortPremiumDesc: '高端车辆，提供卓越舒适度',
    prestigeDesc: '豪华车辆，享受卓越体验',
    vanDesc: '宽敞的团体和家庭车辆',
    aPartirDe: '起价',
    // Booking section
    reservationLabel: '预订',
    bookingTitle1: '预订您的VTC',
    bookingTitle2: '轻松便捷',
    datePriseEnCharge: '接车日期',
    choisirUneDate: '选择日期',
    heurePriseEnCharge: '接车时间',
    choisirUneHeure: '选择时间',
    lieuPriseEnCharge: '接车地点',
    adresseDepart: '出发地址',
    lieuDepot: '送达地点',
    adresseArrivee: '到达地址',
    typeTransfert: '接送类型',
    choisirUnType: '选择类型',
    sensUnique: '单程',
    allerRetour: '往返',
    miseDisposition: '专属包车',
    // Why choose us
    pourquoiNousLabel: '为什么选择我们',
    whyChooseTitle1: '为什么选择',
    whyChooseTitle2: 'Econnect VTC?',
    ponctualite: '守时',
    ponctualiteDesc: '始终准时，实时追踪您的司机。',
    securite: '安全',
    securiteDesc: '经过核实的司机和定期检查的车辆。',
    excellence: '卓越',
    excellenceDesc: '注重每一个细节的高级服务。',
    confort: '舒适',
    confortDesc: '高端、空调完备、维护完好的车辆。',
    // Testimonials
    temoignagesLabel: '客户评价',
    testimonialsTitle1: '客户的',
    testimonialsTitle2: '评价',
    // Footer
    navigation: '导航',
    copyright: '© 2025 Econnect VTC. 版权所有。',
    mentionsLegales: '法律声明',
    politiqueConfidentialite: '隐私政策',
    footerBrandDesc:
      '您的高级出行伙伴。为您所有的商务和个人出行提供优质VTC服务。',
    footerNavAccueil: '主页',
    footerNavServices: '服务',
    footerNavReserver: '预订',
    footerNavApropos: '关于我们',
    footerNavContact: '联系我们',
  },
  ar: {
    // Navbar
    accueil: 'الرئيسية',
    services: 'الخدمات',
    apropos: 'من نحن',
    contact: 'اتصل بنا',
    gamme: 'الأسطول',
    reserver: 'احجز',
    connexion: 'تسجيل الدخول',
    sinscrire: 'إنشاء حساب',
    // Gamme items
    comfortClassique: 'الراحة الكلاسيكية',
    comfortPremium: 'الراحة المميزة',
    prestige: 'البريستيج',
    van: 'فان',
    // Hero
    serviceVtcPremium: 'خدمة VTC المميزة',
    heroTitle1: 'أكثر من مجرد رحلة،',
    heroTitle2: 'تجربة لا تُنسى',
    heroSubtitle:
      'الالتزام الدقيق بالمواعيد، سائقون محترفون وسيارات مُعتنى بها. شريكك اليومي في التنقل.',
    reserverMaintenant: 'احجز الآن',
    nosServices: 'خدماتنا',
    decouvrir: 'اكتشف',
    // Services section
    nosServicesLabel: 'خدماتنا',
    servicesTitle1: 'التميز في خدمة',
    servicesTitle2: 'تنقلك',
    // Service cards
    trajetsPonctuels: 'رحلات منتظمة',
    trajetsPonctuelsSubtitle: 'تنقلك اليومي بسهولة',
    trajetsPonctuelsDesc:
      'حجز سريع، سائقون محترفون وحذرون، سيارات مريحة ومُعتنى بها.',
    miseDispositionTitle: 'تأجير خاص',
    miseDispositionSubtitle: 'سائق خاص',
    miseDispositionDesc:
      'مثالي للتسوق والمواعيد المهنية أو الفعاليات الخاصة. مدة ومسافة قابلة للتعديل.',
    transfertsTitle: 'نقل المحطات والمطارات',
    transfertsSubtitle: 'سافر بكل راحة',
    transfertsDesc:
      'استقبال شخصي باللوحة الاسمية. متابعة الجداول الزمنية في الوقت الفعلي. مساعدة في الأمتعة.',
    affairesTitle: 'الأعمال والفعاليات',
    affairesSubtitle: 'التميز في خدمة صورتك',
    affairesDesc:
      'سائقون بالزي المهني. السرية والتكتم مضمونان. إدارة لوجستية للمجموعات.',
    // Fleet section
    notreFlotte: 'أسطولنا',
    fleetTitle1: 'سيارات',
    fleetTitle2: 'استثنائية',
    // Gamme descriptions
    comfortClassiqueDesc: 'سيدان مريحة لرحلاتك اليومية',
    comfortPremiumDesc: 'سيارات عالية الجودة لراحة فائقة',
    prestigeDesc: 'سيارات فاخرة لتجربة استثنائية',
    vanDesc: 'سيارات واسعة للمجموعات والعائلات',
    aPartirDe: 'ابتداءً من',
    // Booking section
    reservationLabel: 'الحجز',
    bookingTitle1: 'احجز سيارة VTC',
    bookingTitle2: 'بكل سهولة',
    datePriseEnCharge: 'تاريخ الاستلام',
    choisirUneDate: 'اختر تاريخاً',
    heurePriseEnCharge: 'وقت الاستلام',
    choisirUneHeure: 'اختر وقتاً',
    lieuPriseEnCharge: 'مكان الاستلام',
    adresseDepart: 'عنوان المغادرة',
    lieuDepot: 'مكان التسليم',
    adresseArrivee: 'عنوان الوصول',
    typeTransfert: 'نوع النقل',
    choisirUnType: 'اختر النوع',
    sensUnique: 'اتجاه واحد',
    allerRetour: 'ذهاب وإياب',
    miseDisposition: 'تأجير خاص',
    // Why choose us
    pourquoiNousLabel: 'لماذا نحن',
    whyChooseTitle1: 'لماذا تختار',
    whyChooseTitle2: 'Econnect VTC؟',
    ponctualite: 'الالتزام بالمواعيد',
    ponctualiteDesc: 'دائماً في الوقت المحدد، تتبع سائقك في الوقت الفعلي.',
    securite: 'الأمان',
    securiteDesc: 'سائقون معتمدون وسيارات مفحوصة بانتظام.',
    excellence: 'التميز',
    excellenceDesc: 'خدمة متميزة مع الاهتمام بكل تفصيلة.',
    confort: 'الراحة',
    confortDesc: 'سيارات عالية الجودة، مكيفة ومُصانة بشكل مثالي.',
    // Testimonials
    temoignagesLabel: 'آراء العملاء',
    testimonialsTitle1: 'ما يقوله',
    testimonialsTitle2: 'عملاؤنا',
    // Footer
    navigation: 'التنقل',
    copyright: '© 2025 Econnect VTC. جميع الحقوق محفوظة.',
    mentionsLegales: 'الإشعار القانوني',
    politiqueConfidentialite: 'سياسة الخصوصية',
    footerBrandDesc:
      'شريكك المميز في التنقل. خدمة VTC عالية الجودة لجميع تنقلاتك المهنية والشخصية.',
    footerNavAccueil: 'الرئيسية',
    footerNavServices: 'الخدمات',
    footerNavReserver: 'احجز',
    footerNavApropos: 'من نحن',
    footerNavContact: 'اتصل بنا',
  },
  fr: {
    // Navbar
    accueil: 'Accueil',
    services: 'Services',
    apropos: 'À propos',
    contact: 'Contact',
    gamme: 'Gamme',
    reserver: 'Réserver',
    connexion: 'Connexion',
    sinscrire: "S'inscrire",
    // Gamme items
    comfortClassique: 'Confort Classique',
    comfortPremium: 'Confort Premium',
    prestige: 'Prestige',
    van: 'Van',
    // Hero
    serviceVtcPremium: 'Service VTC Premium',
    heroTitle1: "Plus qu'un trajet,",
    heroTitle2: 'une expérience',
    heroSubtitle:
      'Ponctualité rigoureuse, chauffeurs professionnels et véhicules entretenus. Votre partenaire mobilité au quotidien.',
    reserverMaintenant: 'Réserver maintenant',
    nosServices: 'Nos services',
    decouvrir: 'Découvrir',
    // Services section
    nosServicesLabel: 'Nos Services',
    servicesTitle1: "L'excellence au service de",
    servicesTitle2: 'votre mobilité',
    // Service cards
    trajetsPonctuels: 'Trajets Ponctuels',
    trajetsPonctuelsSubtitle: 'Votre mobilité quotidienne simplifiée',
    trajetsPonctuelsDesc:
      'Réservation rapide, chauffeurs professionnels et discrets, véhicules confortables et entretenus.',
    miseDispositionTitle: 'Mise à Disposition',
    miseDispositionSubtitle: 'Chauffeur Privé',
    miseDispositionDesc:
      'Idéal pour shopping, rendez-vous professionnels ou événements privés. Durée et kilométrage ajustables.',
    transfertsTitle: 'Transferts Gares & Aéroports',
    transfertsSubtitle: 'Voyagez en toute sérénité',
    transfertsDesc:
      'Accueil personnalisé avec pancarte nominative. Suivi en temps réel des horaires. Assistance bagages.',
    affairesTitle: 'Affaires & Événementiel',
    affairesSubtitle: "L'excellence au service de votre image",
    affairesDesc:
      'Chauffeurs en tenue professionnelle. Discrétion et confidentialité garanties. Gestion logistique de groupe.',
    // Fleet section
    notreFlotte: 'Notre Flotte',
    fleetTitle1: 'Des véhicules',
    fleetTitle2: "d'exception",
    // Gamme descriptions
    comfortClassiqueDesc: 'Berline confortable pour vos trajets quotidiens',
    comfortPremiumDesc: 'Véhicules haut de gamme pour un confort supérieur',
    prestigeDesc: 'Véhicules de luxe pour une expérience exceptionnelle',
    vanDesc: 'Véhicules spacieux pour groupes et familles',
    aPartirDe: 'À partir de',
    // Booking section
    reservationLabel: 'Réservation',
    bookingTitle1: 'Réservez votre VTC',
    bookingTitle2: 'en toute simplicité',
    datePriseEnCharge: 'Date de prise en charge',
    choisirUneDate: 'Choisir une date',
    heurePriseEnCharge: 'Heure de prise en charge',
    choisirUneHeure: 'Choisir une heure',
    lieuPriseEnCharge: 'Lieu de prise en charge',
    adresseDepart: 'Adresse de départ',
    lieuDepot: 'Lieu de dépôt',
    adresseArrivee: "Adresse d'arrivée",
    typeTransfert: 'Type de transfert',
    choisirUnType: 'Choisir un type',
    sensUnique: 'Sens Unique',
    allerRetour: 'Aller-Retour',
    miseDisposition: 'Mise à Disposition',
    // Why choose us
    pourquoiNousLabel: 'Pourquoi Nous',
    whyChooseTitle1: 'Pourquoi choisir',
    whyChooseTitle2: 'Econnect VTC\u00a0?',
    ponctualite: 'Ponctualité',
    ponctualiteDesc:
      "Toujours à l'heure, suivi en temps réel de votre chauffeur.",
    securite: 'Sécurité',
    securiteDesc: 'Chauffeurs vérifiés et véhicules régulièrement contrôlés.',
    excellence: 'Excellence',
    excellenceDesc: "Service premium avec attention aux moindres détails.",
    confort: 'Confort',
    confortDesc:
      'Véhicules haut de gamme, climatisés et parfaitement entretenus.',
    // Testimonials
    temoignagesLabel: 'Témoignages',
    testimonialsTitle1: 'Ce que disent',
    testimonialsTitle2: 'nos clients',
    // Footer
    navigation: 'Navigation',
    copyright: '© 2025 Econnect VTC. Tous droits réservés.',
    mentionsLegales: 'Mentions légales',
    politiqueConfidentialite: 'Politique de confidentialité',
    footerBrandDesc:
      'Votre partenaire mobilité premium. Service VTC de qualité pour tous vos déplacements professionnels et personnels.',
    footerNavAccueil: 'Accueil',
    footerNavServices: 'Services',
    footerNavReserver: 'Réserver',
    footerNavApropos: 'À propos',
    footerNavContact: 'Contact',
    // Login page
    loginBackHome: "Retour à l'accueil",
    loginSubtitle: 'Accédez à votre espace personnel',
    loginPassword: 'Mot de passe',
    loginSubmit: 'Se connecter',
    loginForgotPassword: 'Mot de passe oublié ?',
    loginNoAccount: 'Pas encore de compte ?',
    loginError: 'Erreur de connexion',
  },
  en: {
    // Navbar
    accueil: 'Home',
    services: 'Services',
    apropos: 'About',
    contact: 'Contact',
    gamme: 'Range',
    reserver: 'Book',
    connexion: 'Login',
    sinscrire: 'Sign up',
    // Gamme items
    comfortClassique: 'Classic Confort',
    comfortPremium: 'Premium Confort',
    prestige: 'Prestige',
    van: 'Van',
    // Hero
    serviceVtcPremium: 'Premium VTC Service',
    heroTitle1: 'More than a ride,',
    heroTitle2: 'an experience',
    heroSubtitle:
      'Strict punctuality, professional drivers and well-maintained vehicles. Your daily mobility partner.',
    reserverMaintenant: 'Book now',
    nosServices: 'Our services',
    decouvrir: 'Discover',
    // Services section
    nosServicesLabel: 'Our Services',
    servicesTitle1: 'Excellence at the service of',
    servicesTitle2: 'your mobility',
    // Service cards
    trajetsPonctuels: 'Point-to-Point Rides',
    trajetsPonctuelsSubtitle: 'Your simplified daily mobility',
    trajetsPonctuelsDesc:
      'Quick booking, professional and discreet drivers, comfortable and well-maintained vehicles.',
    miseDispositionTitle: 'Private Hire',
    miseDispositionSubtitle: 'Personal Chauffeur',
    miseDispositionDesc:
      'Ideal for shopping, professional appointments or private events. Adjustable duration and mileage.',
    transfertsTitle: 'Station & Airport Transfers',
    transfertsSubtitle: 'Travel in complete serenity',
    transfertsDesc:
      'Personalised welcome with name sign. Real-time schedule tracking. Luggage assistance.',
    affairesTitle: 'Business & Events',
    affairesSubtitle: 'Excellence serving your image',
    affairesDesc:
      'Professionally dressed drivers. Guaranteed discretion and confidentiality. Group logistics management.',
    // Fleet section
    notreFlotte: 'Our Fleet',
    fleetTitle1: 'Exceptional',
    fleetTitle2: 'vehicles',
    // Gamme descriptions
    comfortClassiqueDesc: 'Confortable saloon for your daily rides',
    comfortPremiumDesc: 'High-end vehicles for superior comfort',
    prestigeDesc: 'Luxury vehicles for an exceptional experience',
    vanDesc: 'Spacious vehicles for groups and families',
    aPartirDe: 'From',
    // Booking section
    reservationLabel: 'Booking',
    bookingTitle1: 'Book your VTC',
    bookingTitle2: 'with ease',
    datePriseEnCharge: 'Pick-up date',
    choisirUneDate: 'Choose a date',
    heurePriseEnCharge: 'Pick-up time',
    choisirUneHeure: 'Choose a time',
    lieuPriseEnCharge: 'Pick-up location',
    adresseDepart: 'Departure address',
    lieuDepot: 'Drop-off location',
    adresseArrivee: 'Arrival address',
    typeTransfert: 'Transfer type',
    choisirUnType: 'Choose a type',
    sensUnique: 'One Way',
    allerRetour: 'Round Trip',
    miseDisposition: 'Private Hire',
    // Why choose us
    pourquoiNousLabel: 'Why Us',
    whyChooseTitle1: 'Why choose',
    whyChooseTitle2: 'Econnect VTC?',
    ponctualite: 'Punctuality',
    ponctualiteDesc: 'Always on time, real-time tracking of your driver.',
    securite: 'Safety',
    securiteDesc: 'Verified drivers and regularly inspected vehicles.',
    excellence: 'Excellence',
    excellenceDesc: 'Premium service with attention to every detail.',
    confort: 'Confort',
    confortDesc:
      'High-end, air-conditioned and perfectly maintained vehicles.',
    // Testimonials
    temoignagesLabel: 'Testimonials',
    testimonialsTitle1: 'What our',
    testimonialsTitle2: 'clients say',
    // Footer
    navigation: 'Navigation',
    copyright: '© 2025 Econnect VTC. All rights reserved.',
    mentionsLegales: 'Legal Notice',
    politiqueConfidentialite: 'Privacy Policy',
    footerBrandDesc:
      'Your premium mobility partner. Quality VTC service for all your professional and personal journeys.',
    footerNavAccueil: 'Home',
    footerNavServices: 'Services',
    footerNavReserver: 'Book',
    footerNavApropos: 'About',
    footerNavContact: 'Contact',
    // Login page
    loginBackHome: 'Back to home',
    loginSubtitle: 'Access your personal space',
    loginPassword: 'Password',
    loginSubmit: 'Sign in',
    loginForgotPassword: 'Forgot password?',
    loginNoAccount: 'No account yet?',
    loginError: 'Connection error',
  },
  es: {
    // Navbar
    accueil: 'Inicio',
    services: 'Servicios',
    apropos: 'Acerca de',
    contact: 'Contacto',
    gamme: 'Gama',
    reserver: 'Reservar',
    connexion: 'Iniciar sesión',
    sinscrire: 'Registrarse',
    // Gamme items
    comfortClassique: 'Confort Clásico',
    comfortPremium: 'Confort Premium',
    prestige: 'Prestigio',
    van: 'Van',
    // Hero
    serviceVtcPremium: 'Servicio VTC Premium',
    heroTitle1: 'Más que un viaje,',
    heroTitle2: 'una experiencia',
    heroSubtitle:
      'Puntualidad rigurosa, conductores profesionales y vehículos bien mantenidos. Su socio de movilidad diario.',
    reserverMaintenant: 'Reservar ahora',
    nosServices: 'Nuestros servicios',
    decouvrir: 'Descubrir',
    // Services section
    nosServicesLabel: 'Nuestros Servicios',
    servicesTitle1: 'La excelencia al servicio de',
    servicesTitle2: 'su movilidad',
    // Service cards
    trajetsPonctuels: 'Trayectos Puntuales',
    trajetsPonctuelsSubtitle: 'Su movilidad diaria simplificada',
    trajetsPonctuelsDesc:
      'Reserva rápida, conductores profesionales y discretos, vehículos cómodos y mantenidos.',
    miseDispositionTitle: 'Servicio a Disposición',
    miseDispositionSubtitle: 'Chófer Privado',
    miseDispositionDesc:
      'Ideal para compras, citas profesionales o eventos privados. Duración y kilometraje ajustables.',
    transfertsTitle: 'Traslados a Estaciones & Aeropuertos',
    transfertsSubtitle: 'Viaje con total tranquilidad',
    transfertsDesc:
      'Recibimiento personalizado con cartel nominativo. Seguimiento en tiempo real de horarios. Asistencia de equipaje.',
    affairesTitle: 'Negocios y Eventos',
    affairesSubtitle: 'La excelencia al servicio de su imagen',
    affairesDesc:
      'Conductores con uniforme profesional. Discreción y confidencialidad garantizadas. Gestión logística de grupos.',
    // Fleet section
    notreFlotte: 'Nuestra Flota',
    fleetTitle1: 'Vehículos',
    fleetTitle2: 'de excepción',
    // Gamme descriptions
    comfortClassiqueDesc: 'Berlina cómoda para sus trayectos diarios',
    comfortPremiumDesc: 'Vehículos de alta gama para un confort superior',
    prestigeDesc: 'Vehículos de lujo para una experiencia excepcional',
    vanDesc: 'Vehículos espaciosos para grupos y familias',
    aPartirDe: 'Desde',
    // Booking section
    reservationLabel: 'Reserva',
    bookingTitle1: 'Reserve su VTC',
    bookingTitle2: 'con total facilidad',
    datePriseEnCharge: 'Fecha de recogida',
    choisirUneDate: 'Elegir una fecha',
    heurePriseEnCharge: 'Hora de recogida',
    choisirUneHeure: 'Elegir una hora',
    lieuPriseEnCharge: 'Lugar de recogida',
    adresseDepart: 'Dirección de salida',
    lieuDepot: 'Lugar de entrega',
    adresseArrivee: 'Dirección de llegada',
    typeTransfert: 'Tipo de traslado',
    choisirUnType: 'Elegir un tipo',
    sensUnique: 'Solo ida',
    allerRetour: 'Ida y vuelta',
    miseDisposition: 'Servicio a Disposición',
    // Why choose us
    pourquoiNousLabel: 'Por qué nosotros',
    whyChooseTitle1: '¿Por qué elegir',
    whyChooseTitle2: 'Econnect VTC?',
    ponctualite: 'Puntualidad',
    ponctualiteDesc: 'Siempre a tiempo, seguimiento en tiempo real de su conductor.',
    securite: 'Seguridad',
    securiteDesc: 'Conductores verificados y vehículos controlados regularmente.',
    excellence: 'Excelencia',
    excellenceDesc: 'Servicio premium con atención a cada detalle.',
    confort: 'Confort',
    confortDesc:
      'Vehículos de alta gama, climatizados y perfectamente mantenidos.',
    // Testimonials
    temoignagesLabel: 'Testimonios',
    testimonialsTitle1: 'Lo que dicen',
    testimonialsTitle2: 'nuestros clientes',
    // Footer
    navigation: 'Navegación',
    copyright: '© 2025 Econnect VTC. Todos los derechos reservados.',
    mentionsLegales: 'Aviso Legal',
    politiqueConfidentialite: 'Política de Privacidad',
    footerBrandDesc:
      'Su socio de movilidad premium. Servicio VTC de calidad para todos sus desplazamientos profesionales y personales.',
    footerNavAccueil: 'Inicio',
    footerNavServices: 'Servicios',
    footerNavReserver: 'Reservar',
    footerNavApropos: 'Acerca de',
    footerNavContact: 'Contacto',
    // Login page
    loginBackHome: 'Volver al inicio',
    loginSubtitle: 'Acceda a su espacio personal',
    loginPassword: 'Contraseña',
    loginSubmit: 'Iniciar sesión',
    loginForgotPassword: '¿Olvidó su contraseña?',
    loginNoAccount: '¿Aún no tiene cuenta?',
    loginError: 'Error de conexión',
  },
};

export default translations;
